'use strict';

const PickerPresenter = require('./picker');

class SectionPickerPresenter extends PickerPresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const hash = super.toHash(...arguments);
    if (this.selected()) {
      hash.selectedSection = { title: this.selected().getTitle() };
    }
    hash.isTouch = this.collection.meta('isTouch');
    return hash;
  }
}

module.exports = SectionPickerPresenter;
